import { render, staticRenderFns } from "./CatalogClientDataStep.vue.html?vue&type=template&id=4212f2a3&"
import script from "./CatalogClientDataStep.component.js?vue&type=script&lang=vueJs&"
export * from "./CatalogClientDataStep.component.js?vue&type=script&lang=vueJs&"
import style0 from "./CatalogClientDataStep.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports